// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"c19275d3","163":"305e4f4a","248":"9930cd22","254":"ee2f1f73","257":"6549dc12","287":"f5169cf8","292":"56da02df","457":"24d57d2f","538":"d999211c","788":"20575827","938":"998f4efe"}[chunkId] + ".chunk.js";
};